import * as Constants from './constants'

export const contractsListRequest = function contractsListRequest(formData) {
  return {
    type: Constants.CONTRACTS_LIST_REQUESTING,
    payload: formData
  }
}

export const contractsListSuccess = function contractsListSuccess(data) {
  return {
    type: Constants.CONTRACTS_LIST_SUCCESS,
    data
  }
}

export const contractsListError = function contractsListError(error) {
  return {
    type: Constants.CONTRACTS_LIST_ERROR,
    error
  }
}

export const contractsDetailRequest = function contractsDetailRequest(formData) {
  return {
    type: Constants.CONTRACTS_DETAIL_REQUESTING,
    payload: formData
  }
}

export const contractsDetailSuccess = function contractsDetailSuccess(data) {
  return {
    type: Constants.CONTRACTS_DETAIL_SUCCESS,
    data
  }
}

export const contractsDetailError = function contractsDetailError(error) {
  return {
    type: Constants.CONTRACTS_DETAIL_ERROR,
    error
  }
}

export const contractsUpdateRequest = (formData, callback) => {
  return {
    type: Constants.CONTRACTS_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const contractsUpdateSuccess = function contractsUpdateSuccess(response) {
  return {
    type: Constants.CONTRACTS_UPDATE_SUCCESS,
    payload: response
  }
}

export const contractsUpdateError = function contractsUpdateError(error) {
  return {
    type: Constants.CONTRACTS_UPDATE_ERROR,
    error
  }
}

export const contractsTrangThaiRequest = function contractsTrangThaiRequest(formData) {
  return {
    type: Constants.CONTRACTS_TRANGTHAI_REQUESTING,
    payload: formData
  }
}

export const contractsTrangThaiSuccess = function contractsTrangThaiSuccess(data) {
  return {
    type: Constants.CONTRACTS_TRANGTHAI_SUCCESS,
    data
  }
}

export const contractsTrangThaiError = function contractsTrangThaiError(error) {
  return {
    type: Constants.CONTRACTS_TRANGTHAI_ERROR,
    error
  }
}

export const contractsLoaiRequest = function contractsLoaiRequest(formData) {
  return {
    type: Constants.CONTRACTS_LOAI_REQUESTING,
    payload: formData
  }
}

export const contractsLoaiSuccess = function contractsLoaiSuccess(data) {
  return {
    type: Constants.CONTRACTS_LOAI_SUCCESS,
    data
  }
}

export const contractsLoaiError = function contractsLoaiError(error) {
  return {
    type: Constants.CONTRACTS_LOAI_ERROR,
    error
  }
}

export const contractsNhanVienRequest = function contractsNhanVienRequest(formData) {
  return {
    type: Constants.CONTRACTS_NHANVIEN_REQUESTING,
    payload: formData
  }
}

export const contractsNhanVienSuccess = function contractsNhanVienSuccess(data) {
  return {
    type: Constants.CONTRACTS_NHANVIEN_SUCCESS,
    data
  }
}

export const contractsNhanVienError = function contractsNhanVienError(error) {
  return {
    type: Constants.CONTRACTS_NHANVIEN_ERROR,
    error
  }
}

export const contractsKhachHangRequest = (formData, callback) => {
  return {
    type: Constants.CONTRACTS_KHACHHANG_REQUESTING,
    payload: formData,
    callback
  }
}

export const contractsKhachHangSuccess = (data) => {
  return {
    type: Constants.CONTRACTS_KHACHHANG_SUCCESS,
    data
  }
}

export const contractsKhachHangError = function contractsKhachHangError(error) {
  return {
    type: Constants.CONTRACTS_KHACHHANG_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Contracts/actions.js